export const getSimilarityClassificationDisplayName = (
  classification: string | undefined,
) => {
  if (classification === "C801") return "Filing";
  if (classification === "C802") return "Filing";
  if (classification === "C006") return "Press";
  if (classification === "C021") return "Press";
  if (classification === "") return "-";
  return classification;
};
